import { Injectable } from '@angular/core';

import { SceneUtilsService } from './scene-utils.service';
import { StageService } from './stage.service';
import { Select3dService } from './select-3d.service';
import { ConstantsService } from './constants.service';
import { SetWallMaterialService } from './set-wall-material.service';
import { WallBuilderService } from './wall/wall-builder.service';
import { EventLogService, Actions } from './eventLog';
import { InteractiveSpriteComponentBase } from '../interactive-sprite-component-base';
import {AutoScaleSprite} from '../custom/AutoScaleSprite';

declare const THREE: any;

@Injectable()
export class BuildWallService extends InteractiveSpriteComponentBase {

  constructor(
    private stage: StageService,
    private sceneUtils: SceneUtilsService,
    private select3dService: Select3dService,
    private constantsService: ConstantsService,
    private wallMaterialSrvc: SetWallMaterialService,
    private wallBuilder: WallBuilderService,
    private eventLog: EventLogService
  ) {
    super();
    this.disable();
  }

  private material: string;
  private selectTierSubscription: any;
  sprites = [];
  loader = new THREE.TextureLoader();
  isActive = false;
  stairStep: any;
  stairsPositions: any = [];
  angle: any;
  stairStepPromise: Promise<any>;
  private raycaster: any = new THREE.Raycaster();

  drawSprites() {
    this.material = this.wallMaterialSrvc.getCurrentTextureUrl();
    const section = this.wallMaterialSrvc.currentSection;
    let spriteImageUrl = '../../assets/images/sprites/';
    // let spriteImageUrl = this.wallMaterialSrvc.getCurrentTextureToSprite();
    switch (section) {
      case 'wood': {
        spriteImageUrl += 'Wood_wall.png';
      }
        break;
      case 'stucco': {
        spriteImageUrl += 'Stucco_wall.png';
      }
        break;
      case 'brick': {
        spriteImageUrl += 'Brick_wall.png';
      }
        break;
      case 'stone': {
        spriteImageUrl += 'Stone_wall.png';
      }
        break;
      case 'metal': {
        spriteImageUrl += 'Metal_wall.png';
      }
        break;
      case 'panels': {
        spriteImageUrl += 'Panels_wall.png';
      }
        break;
      default: {
        spriteImageUrl = this.wallMaterialSrvc.getCurrentTextureToSprite() || (spriteImageUrl + 'Brick_wall.png');
      }
        break;
    }
    let counter = 0;
    const floor = this.select3dService.getSelectedTier();
    const points = floor.userData.points;
    const count = points.length;
    const height = floor.getWorldPosition(new THREE.Vector3()).y + 5;

    for (let i = 0; i < points.length; i++) {
      if (!floor.userData.edges[i].firstPoint.superstructureType) {
        const spriteMap = this.loader.load(spriteImageUrl);

        const spriteMaterial = new THREE.SpriteMaterial({ map: spriteMap, color: 0xffffff, depthTest: false, depthWrite: false });

        const sprite = new AutoScaleSprite(50, 50, spriteMaterial);

        const floorHeight = floor.getWorldPosition(new THREE.Vector3()).y,
          heightAboveDeck = this.constantsService.wallHeight,
          wallHeight = heightAboveDeck + floorHeight,
          edgeLength = Math.sqrt(
            Math.pow((points[i].x - points[(i + 1) % count].x), 2) +
            Math.pow((points[i].y - points[(i + 1) % count].y), 2)
          );

        sprite.userData.config = {
          previousPoint: points[i > 0 ? i - 1 : count - 1],
          firstPoint: points[i],
          secondPoint: points[(i + 1) % count],
          nextPoint: points[(i + 2) % count],
          superstructureType: 'wall',
          width: edgeLength,
          height: wallHeight,
          floorId: floor.id,
          material: this.material,
          distance: edgeLength / 2
        };

        this.sprites.push(sprite);
        this.sprites[counter].position.set(
          (points[i].x + points[(i + 1) % points.length].x) / 2,
          height,
          (points[i].y + points[(i + 1) % points.length].y) / 2
        );
        this.stage.add(this.sprites[counter]);
        counter++;
      }
    }
  }

  mouseDown(e: MouseEvent) {
    const p = this.sceneUtils.getRay(e.offsetX, e.offsetY);
    this.raycaster.ray.origin.copy(p.ray.origin);
    this.raycaster.ray.direction.copy(p.ray.direction);

    const intersection = this.raycaster.intersectObjects(this.sprites);
    if (intersection.length) {
      const wall = this.wallBuilder.createWall(intersection[0].object.userData.config);
      this.eventLog.dispatch(new Actions.AddWallAction(wall.userData.uuid));
      this.removeSprites();
    }
  }

  removeSprites() {
    this.stage.removeMany(this.sprites);
    this.sprites.splice(0, this.sprites.length);
  }

  disable() {
    this.removeSprites();
    this.selectTierSubscription && this.selectTierSubscription.unsubscribe();
    super.disable();
  }

  enable() {
    super.enable();
    if (!this.selectTierSubscription || this.selectTierSubscription.isStopped) {
      this.selectTierSubscription = this.select3dService.selectedTierSubject.subscribe(value => {
        if (this.isEnabled()) {
          this.removeSprites();
          this.drawSprites();
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/services/build-wall.service.ts